import { useSearchParams } from 'react-router-dom'
import { useDebounce } from 'use-debounce'
import { browserTimeZone } from 'utils/time'

export default function useListQuery(defaults = {}, dateKeys = []) {
  const [params, setParams] = useSearchParams()
  const change = (key, value) => {
    const next = new URLSearchParams(params)
    value ? next.set(key, value) : next.delete(key)
    if (key !== 'page') next.delete('page')
    setParams(next)
  }
  const changeDate = (key, value) => {
    const next = new URLSearchParams(params)
    value ? next.set(key, value) : next.delete(key)
    if (dateKeys.some(dateKey => next.get(dateKey))) next.set('timeZone', browserTimeZone())
    else next.delete('timeZone')
    next.delete('page')
    setParams(next)
  }
  const request = new URLSearchParams(params)
  Object.entries(defaults).forEach(([key, value]) => {
    if (!request.has(key)) request.set(key, value)
  })
  const timeZone = request.get('timeZone') || browserTimeZone()
  const [requestQuery] = useDebounce(request.toString(), 300)
  return { params, setParams, change, changeDate, requestQuery, timeZone }
}
